var exports = {
  "n": "x52a3aa3b--08bd3c--link",
};

module.exports = exports;
